// eslint-disable-next-line import/prefer-default-export
export const STATIC_ACCESS_POINT_URL = 'https://slot.tizeti.com/geniatechapi/index.php';
export const ACCESS_PERFORMANCE_URL = 'https://slot.tizeti.com/cnmaestro/Views/index.php';
